import React from "react"
import TablePlan from "../../Components/Plans/TablePlan"
import TablePlanCard from "../../Components/Plans/TablePlanCard"
import {Button, Card, Col, Form, Icon, Input, message, Modal, Radio, Row, Spin, Steps, Tooltip, Typography} from "antd"
import {withBreakpoints} from "react-breakpoints"
import {API, Auth} from "aws-amplify"
import {withRouter} from 'react-router-dom'
import '../../Styles/UserPanel/Invoice.css'
import RadioGroup from "antd/lib/radio/group";
import RadioButton from "antd/lib/radio/radioButton";
import {connect} from "react-redux"
import {CustomSpinner} from "../../Components/Spin/CustomSpiner"
import {allDispatch as mapDispatchToProps, allState as mapStateToProps} from "../../Redux/Selectors"
import moment from "moment";

const {Paragraph, Title, Text} = Typography;
const {Step} = Steps;


class UpgradePlan extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            medioPago: 'Tarjeta',
            loading: true,
            costoPlus: 0,
            costoPremium: 0,
            costoAplicaciones: 0,
            user: {},
            paymentResponse: {
                transaction_details: {
                    external_resource_url: 'http://www.google.com'
                }
            },
            currentStep: 0,
            tipoPlan: 'Aplicaciones',
            trabajaEnAplicacion: this.props.login.user_data.trabaja_aplicacion || false,
            planSelected: '',
            currentKey: 0,
            plans: [],
            payment_data: {
                nombre: '',
                apellido: '',
                dni: null,
                mes: 1,
                año: new Date().getFullYear(),
                codigoSeguridad: 0,
                montoCobro: null,
                medioPago: '',//credit_card, debit_card, ticket
                medioPagoId: '',// visa, master, naranja, diners, etc
                numeroTarjeta: null,
                entidad: "", //rapipago, pagofacil,
            },
            codigo: null,
            loadingCodigo: false,
            codigoValido: null,
            codigoResponse: null
        };
    }

    getAdminLites = () => {
        this.setState({loadingAdminLites: true})
        localStorage.removeItem("adminLiteSelected")
        Auth.currentSession()
            .then(session => {
                API.get(
                    'test',
                    '/root/admindashboard/adminlites/',
                    {
                        headers: {
                            Authorization: session.getIdToken().getJwtToken()
                        },

                    }
                )
                    .then(response => {
                        this.setState({loadingAdminLites: false, adminLites: response});
                    })
                    .catch(err => {
                        message.error("Error al cargar listado de empresas")
                        this.setState({loadingCodigo: false, codigoValido: false})
                        console.log(err)
                    })
            })

    }

    validarCodigo = () => {
        this.setState({loadingCodigo: true, codigoValido: null, codigoResponse: null})

        Auth.currentSession()
            .then(session => {
                API.get(
                    'test',
                    '/root/admindashboard/code/' + this.state.codigo,
                    {
                        headers: {
                            Authorization: session.getIdToken().getJwtToken()
                        },

                    }
                )
                    .then(response => {
                        if (response && response[0] && response[0].cuit) {
                            this.setState({loadingCodigo: false, codigoValido: true, codigoResponse: response[0]});
                            this.setState({trabajaEnAplicacion: false});
                            this.props.form.setFieldsValue({trabaja_aplicacion: false});
                        } else {
                            this.setState({loadingCodigo: false, codigoValido: false})
                        }
                    })
                    .catch(err => {
                        this.setState({loadingCodigo: false, codigoValido: false})
                        console.log(err)
                    })
            })
    }

    componentDidMount() {
        let año = new Date().getFullYear()
        let initialStep
        if (this.props.stepsUser) {
            initialStep = this.props.initialStep
        } else {
            initialStep = 2
        }
        this.setState({currentStep: initialStep, añoActual: año, loading: true, user: this.props.login.user_data})
        this.getAdminLites();
        Auth.currentSession()
            .then(session => {
                API.get(
                    'test',
                    '/taxes/planes',
                    {
                        headers: {
                            Authorization: session.getIdToken().getJwtToken()
                        },

                    }
                )
                    .then(response => {
                        let plusMin = response.filter(p => p.plan === 'Plus').sort((a, b) => (a.costo > b.costo) ? -1 : (a.costo < b.costo) ? 1 : 0)[0]
                        let premiumMin = response.filter(p => p.plan === 'Premium').sort((a, b) => (a.costo > b.costo) ? -1 : (a.costo < b.costo) ? 1 : 0)[0]
                        let aplicacionesMin = response.filter(p => p.plan === 'Aplicaciones').sort((a, b) => (a.costo > b.costo) ? -1 : (a.costo < b.costo) ? 1 : 0)[0]
                        let planSelectedInital = response[0].planId
                        this.setState({
                            costoPlus: parseInt(plusMin.costo / plusMin.plazo),
                            costoPremium: parseInt(premiumMin.costo / premiumMin.plazo),
                            costoAplicaciones: parseInt(aplicacionesMin.costo / aplicacionesMin.plazo),
                            loading: false,
                            plans: response,
                            planSelected: planSelectedInital
                        })

                    })
                    .catch(err => {
                        message.error("Error leyendo planes")
                        console.log(err)

                    })
            })

    }

    updateData(field, value) {
        const data = this.state.payment_data
        data[field] = value
        this.setState({payment_data: data})
    }

    updateUser(field, value) {
        const data = this.state.user
        data[field] = value
        this.setState({user: data})
    }


    changePayment(field, value) {
        this.setState({medioPago: value})

    }


    prev() {
        let actualStep = this.state.currentStep
        switch (actualStep) {
            case 1:
                this.setState({currentStep: 0})
                break;
            case 2:
                this.props.form.resetFields(['tipo-plan'])
                this.setState({currentStep: 1, trabajaEnAplicacion: false})
                break;
            case 3:
                this.props.form.resetFields(['medio-pago'])
                this.setState({currentStep: 2, medioPago: 'Tarjeta'})
                break;
            default:
                this.setState({currentStep: this.state.currentStep - 1})
                break;
        }

    }


    next(value = 0) {
        let actualStep = this.state.currentStep

        switch (actualStep) {
            case 0:
                this.setState({currentStep: 1})
                break;

            case 1:
                this.props.form.validateFields(['trabaja_aplicacion'], (err, values) => {
                    if (!err) {
                        if (this.state.codigoValido) {
                            message.success("Código validado con éxito")
                            this.adminLiteSelected(true);
                        } else {
                            this.adminLiteSelected(false);
                        }
                    }
                })
                break;

            case 2:
                this.setState({currentStep: 3, tipoPlan: value})
                break;

            case 3:
                this.setState({planSelected: value})
                this.call_mercadopago(value)
                break;

            default:
                break;
        }
    }

    call_mercadopago(planSelected) {
        let body = {}
        if (this.props.stepsUser === true) {
            body = {
                plan_id: planSelected,
                plan: this.state.tipoPlan,
                trabaja_aplicacion: this.state.trabajaEnAplicacion
            }
        } else {
            body = {
                plan_id: planSelected,
                plan: this.state.tipoPlan,
            }
        }
        Auth.currentSession()
            .then(session => {
                API.put(
                    'test',
                    '/root/users/me/plan',
                    {
                        headers: {
                            Authorization: session.getIdToken().getJwtToken()
                        },
                        body: body
                    }
                )
                    .then(response => {
                        message.success("Plan actualizado correctamente")
                        let user = this.props.login.user_data
                        user['plan'] = this.state.tipoPlan
                        user['plan_id'] = this.state.planSelected
                        user['trabaja_aplicacion'] = this.state.trabajaEnAplicacion
                        this.props.UserDataLoad(user)
                        this.props.history.push('/medio-pago/' + planSelected, {state:{myPlan: planSelected}})
                    })
                    .catch(err => {
                        message.error("Hubo un error actualizando el plan")
                        this.props.history.push('/')
                        console.log(err)
                    })
            })


    }


    adminLiteSelected = async (conCodigo = false) => {
        let user = this.props.login.user_data;
        const session = await Auth.currentSession();

        if (conCodigo) {
            const planId = this.state.plans.filter(p => p.plan === 'Codigo')[0].planId;
            const plan = 'Codigo'
            let body = {}
            if (this.props.stepsUser === true) {
                body = {
                    plan_id: planId,
                    plan: plan,
                    trabaja_aplicacion: this.state.trabajaEnAplicacion
                }
            } else {
                body = {
                    plan_id: planId,
                    plan: plan,
                }
            }

            user['plan'] = plan
            user['plan_id'] = planId;
            user['estado_pago'] = 'ACTIVO';
            this.props.UserDataLoad(user);

            try {
                const response = await API.put(
                    'test',
                    '/root/users/me/plan',
                    {
                        headers: {
                            Authorization: session.getIdToken().getJwtToken()
                        },
                        body: body
                    }
                )
            } catch (e) {
                message.error("Hubo un error actualizando el plan")
                this.props.history.push('/')
                console.log(e)
            }

        }

        const [userCognito] = await Promise.all([
            Auth.currentUserInfo()
        ]);

        try {

            if(this.state.adminLiteSelected){

                await API.post(
                    'test',
                    '/root/admindashboard/relationship/user/create',
                    {
                        headers: {
                            Authorization: session.getIdToken().getJwtToken()
                        },
                        body: {
                            adminCuit: this.state.adminLiteSelected.cuit,
                            userId: userCognito.username,
                            razonSocial: this.state.adminLiteSelected.razon_social,
                            domicilio: this.state.adminLiteSelected.domicilio,
                            tipoResponsable: this.state.adminLiteSelected.id_impositivo,
                            nombreUsuario: user.nombre,
                            apellidoUsuario: user.apellido,
                            emailUsuario: user.email,
                            telefonoUsuario: user.telefono,
                            cuitUsuario: null,
                            fecha_desde: moment().format('YYYY-MM-DD'),
                            fecha_hasta: null,

                        }
                    }
                );
            }

        } catch (e) {
            message.error("Hubo un error cargarndo la relación laboral");
            console.error(e)
            return;
        }


        if(conCodigo){
            this.props.history.push('/', {state: {data: {adminLite: this.state.adminLiteSelected}}})
        } else {
            this.setState({currentStep: 2})
        }


    }


    render() {
        if (this.state.loading) {
            return (
                <>
                    <Row></Row>
                    <Row type="flex" justify="space-around" align="middle" style={{marginTop: '150px'}}>
                        <Col style={{minHeight: '360px'}}>
                            <Spin indicator={CustomSpinner}/>
                        </Col>
                    </Row>
                    <Row></Row>
                </>)
        } else {

            const tipoPlan = this.state.plans.filter(planes => planes.plan === this.state.tipoPlan)
            tipoPlan.sort((a, b) => (a.plazo > b.plazo) ? 1 : ((a.plazo < b.plazo) ? -1 : 0))
            const plan = tipoPlan.filter(plan => plan.medio === this.state.medioPago)
            
            const {getFieldDecorator} = this.props.form;


            const noNullValidator = (rule, value, callback) => {
                if (value === undefined || value === null) {
                    callback("Seleccione una opcion")
                } else {
                    callback()
                }
            }

            const planAplicaciones = {
                title: 'Elegí tu plan',
                content:
                    <>
                        <Form.Item>
                            {
                                getFieldDecorator('tipo-plan', {
                                    initialValue: null,
                                    value: this.state.tipoPlan,
                                    rules: [{
                                        required: true,
                                    }],
                                })(
                                    <Radio.Group onChange={(e) => this.next(e.target.value)}
                                                 buttonStyle='solid'
                                                 optionType='button'
                                                 style={{width: '100%'}}
                                    >
                                        <Row gutter={[24]} type='flex' justify='center' align='top'>

                                            <Col lg={6} xs={24} style={{marginBottom: '10px', marginTop: '5px'}}>
                                                <TablePlan
                                                    title={"Aplicaciones"}
                                                    subtitle="por mes"
                                                    color="linear-gradient(90deg, #49EBAC 0%, #44C3B8 100%)"
                                                    price={this.state.costoAplicaciones}
                                                    content={['Alta en monotributo','Facturación',
                                                        'Alertas y notificaciones automáticas', 'Indicadores estadísticos de facturación',
                                                        'Emisión de Volantes de pago para cuota de monitributo', 
                                                        'Recategorización semestral en monotributo','-','-','-','-']}
                                                    button_value={"Aplicaciones"}
                                                    
                                                    
                                                />
                                            </Col>
                                            <Col lg={6} xs={24} style={{marginBottom: '5px', marginTop: '5px'}}>
                                                <TablePlan
                                                    title={"Plus"}
                                                    subtitle="por mes"
                                                    color="linear-gradient(90deg, #49EBAC 0%, #44C3B8 100%)"
                                                    price={this.state.costoPlus}
                                                    content={['Alta en monotributo', 'Alta en Ingresos Brutos',
                                                        'Facturación', 'Alertas y notificaciones automáticas',
                                                        'Indicadores estadísticos de facturación','Emisión de Volantes de Pago para cuota de monotributo',
                                                        'Recategorización semestral en monotributo','-','-','-']}
                                                    button_value={"Plus"}
                                                    
                                                    
                                                />
                                            </Col>
                                            <Col lg={6} xs={24} style={{marginBottom: '5px', marginTop: '5px'}}>
                                                <TablePlan
                                                    title={"Premium"}
                                                    subtitle="por mes"
                                                    // color="linear-gradient(to right, #49EBAC, #44C3B8)"
                                                    color= "linear-gradient(90deg, #49EBAC 0%, #44C3B8 100%)"
                                                    price={this.state.costoPremium}
                                                    content={['Alta en monotributo', 'Alta en Ingresos Brutos','Facturación',
                                                        'Liquidación mensual de ingresos brutos','Indicadores estadísticos de facturación', 'Alertas y notificaciones automáticas',
                                                         'Emisión de Volantes de Pago para cuota de monotributo', 'Recategorización semestral en monotributo',
                                                        'Generación de planes de pago', 'Asesoramiento Profesional']}
                                                    button_value={"Premium"}
                                                />
                                            </Col>
                                        </Row>
                                    </Radio.Group>
                                )
                            }
                        </Form.Item>

                    </>
            }


            const steps = [
                {

                    title: '',
                    icon: 'user',
                    content:
                        <>
                            <Paragraph className="ant-typography-stepsuser"><b>¡Configuremos tu cuenta!</b></Paragraph>
                            <Paragraph className="ant-typography-stepsuser">
                                En los próximos pasos vas a:
                            </Paragraph>
                            <Paragraph className="ant-typography-stepsuser-text">
                            👌 Elegir el plan que mejor se adapte a tus necesidades
                            </Paragraph>
                            <Paragraph className="ant-typography-stepsuser-text">
                            📑 Responder algunas preguntas básicas para que te inscribamos en monotributo y te asesoremos de la mejor manera!
                            </Paragraph>
                            <Paragraph className="ant-typography-stepsuser-text">
                            <b>Si tenés alguna duda en alguna parte del proceso escribinos por Whatsapp usando el ícono ubicado abajo a la derecha</b>
                            </Paragraph>
                            
                            {/* <Paragraph className="ant-typography-stepsuser"><b>Gracias por elegirnos!</b>
                            </Paragraph> */}
                        </>
                },
                {
                    title: '¿Vas a colaborar con alguna de estas empresas?',
                    content:
                        <div>
                            <Form.Item>
                                {
                                    getFieldDecorator('trabaja_aplicacion', {
                                        initialValue: null,
                                        value: this.state.trabajaEnAplicacion,
                                        rules: [{
                                            required: true,
                                        }],
                                    })(
                                        <>
                                            <div style={{
                                                flexDirection: 'row',
                                                justifyContent: 'center',
                                                alignItems: 'center'
                                            }}>
                                                {
                                                    (this.state.adminLites ? this.state.adminLites : []).filter(a => a.active_signup).map(adminLite => (
                                                        <Button key={adminLite.cuit} style={{marginRight: 15}}
                                                                onClick={() => {
                                                                    if (!adminLite.is_code_active) {
                                                                        this.setState({
                                                                            trabajaEnAplicacion: true,
                                                                            adminLiteSelected: adminLite
                                                                        });
                                                                        this.props.form.setFieldsValue({trabaja_aplicacion: true});
                                                                        this.next();
                                                                    } else {
                                                                        this.setState({
                                                                            trabajaEnAplicacion: false,
                                                                            adminLiteSelected: adminLite,
                                                                            modalVisible: true
                                                                        });
                                                                    }
                                                                }}
                                                        >
                                                            {adminLite.display_name || adminLite.razon_social}
                                                        </Button>
                                                    ))
                                                }
                                                <Button style={{marginRight: 15}}
                                                        onClick={() => {
                                                            this.setState({trabajaEnAplicacion: false});
                                                            this.props.form.setFieldsValue({trabaja_aplicacion: false});
                                                            this.next();
                                                        }}
                                                >
                                                    Ninguna de las anteriores
                                                </Button>
                                            </div>
                                        </>
                                    )
                                }
                            </Form.Item>
                            <Modal
                                title={"Ingrese su codigo de activacion"}
                                width={700}
                                visible={this.state.modalVisible}
                                onCancel={() => this.setState({modalVisible: false})}
                                footer={[
                                    <Button key="back" onClick={() => this.setState({modalVisible: false})}>
                                        Cancelar
                                    </Button>,
                                    <Button key="submit" type="primary"
                                            disabled={!this.state.codigoValido}
                                            onClick={() => {
                                                this.setState({adminLite: this.state.adminLiteSelected})
                                                localStorage.setItem("adminLiteSelected", JSON.stringify(this.state.adminLiteSelected))
                                                this.next();
                                            }}>
                                        Continuar
                                    </Button>,
                                ]}
                            >
                                <Input style={{width: 300}}
                                       onChange={e => this.setState({codigo: e.target.value})}
                                       placeholder="Codigo"
                                       suffix={
                                           (this.state.codigoValido ?
                                               <Icon style={{color: 'green'}} type="check-circle"/> :
                                               this.state.codigoValido === false ?
                                                   (
                                                       <Tooltip title="Codigo invalido">
                                                           <Icon style={{color: 'red'}} type="close-circle"/>
                                                       </Tooltip>) : null)
                                       }
                                />
                                <Button style={{marginLeft: 20}}
                                        loading={this.state.loadingCodigo}
                                        type="primary"
                                        onClick={() => {
                                            this.validarCodigo();
                                        }}
                                >
                                    Validar
                                </Button>
                                <br/>
                                {this.state.codigoValido && this.state.codigoResponse ? (
                                    <Paragraph
                                        style={{marginTop: 15}}>CUIT: {this.state.codigoResponse.cuit} - {this.state.codigoResponse.razon_social}</Paragraph>
                                ) : null}
                            </Modal>
                        </div>

                },
                {
                    title: 'Elegí tu plan',
                    content:
                        <>

                            <Form.Item>
                                { this.state.stepsUser &&
                                    <Text level={3}
                                    style={{ color: "#FFF"}}
                                    >
                                        Después que elijas el plan y efectúes el pago, realizaremos tu alta en Monotributo y habilitaremos tu facturación
                                </Text>}
                                {
                                    getFieldDecorator('tipo-plan', {
                                        initialValue: null,
                                        value: this.state.tipoPlan,
                                        rules: [{
                                            required: true,
                                        }],
                                    })(
                                        <Radio.Group onChange={(e) => this.next(e.target.value)}
                                                     buttonStyle='solid'
                                                     optionType='button'
                                                     style={{width: '100%'}}
                                        >
                                            <Row gutter={[24, 10]} type='flex' justify='center' align='top'>

                                                <Col lg={8} xs={24}>
                                                    <TablePlan
                                                        title={"Plus"}
                                                        subtitle="POR MES"
                                                        // color="linear-gradient(to right, #49EBAC, #44C3B8)"
                                                        color="linear-gradient(90deg, #49EBAC 0%, #44C3B8 100%)"
                                                        // color= "#353FDF"
                                                        price={this.state.costoPlus}
                                                        content={['Alta en monotributo', 'ALta en Ingresos Brutos',
                                                        'Facturación', 'Alertas y notificaciones automáticas',
                                                        'Indicadores estadísticos de facturación', 'Emisión de Volantes de Pago para cuota de monotributo',
                                                        'Recategorización semestral en monotributo', '-','-','-']}
                                                        button_value={"Plus"}
                                                    />
                                                </Col>
                                                <Col lg={8} xs={24}>
                                                    <TablePlan
                                                        title={"Premium"}
                                                        subtitle="POR MES"
                                                        // color="linear-gradient(to right, #49EBAC, #44C3B8)"
                                                        color="linear-gradient(90deg, #49EBAC 0%, #44C3B8 100%)"
                                                        // color= "#353FDF"
                                                        price={this.state.costoPremium}
                                                        content={['Alta en monotributo', 'Alta en Ingresos Brutos',
                                                        'Liquidación mensual de ingresos brutos', 'Facturación', 'Alertas y notificaciones automáticas',
                                                        'Indicadores estadísticos de facturación', 'Emisión de Volantes de Pago para cuota de monotributo', 'Recategorización semestral en monotributo',
                                                        'Generación de planes de pago', 'Asesoramiento Profesional']}
                                                        button_value={"Premium"}
                                                    />
                                                </Col>
                                            </Row>

                                        </Radio.Group>
                                    )
                                }
                            </Form.Item>

                        </>
                },
                {
                    title: '¿Cómo lo vas a pagar?',
                    content:
                        <>
                            <Form.Item>
                                {
                                    getFieldDecorator('medio-pago', {
                                        rules: [
                                            {
                                                required: true
                                            }
                                        ],
                                        value: this.state.medioPago
                                    })(
                                        <Row type='flex' justify='center' align='top' gutter={[8, 8]}>
                                            <Col>
                                                <RadioGroup
                                                    onChange={(e) => this.changePayment("medioPago", e.target.value)}
                                                    buttonStyle='solid'
                                                    optionType='button'
                                                    defaultValue='Tarjeta'
                                                >
                                                    <RadioButton value={'Tarjeta'}
                                                    style={{
                                                        marginRight: '10px',
                                                        marginBottom: '10px',
                                                        border: '1px solid #FFF',
                                                        borderRadius: '5px',
                                                        // background: 'linear-gradient(90deg, #49EBAC 0%, #44C3B8 100%)'
                                                        

                                                    }}>Tarjeta de Débito o Crédito</RadioButton>
                                                    <RadioButton value={'Otros'}
                                                     className = 'other-payment-button'
                                                     style={{
                                                        marginRight: '10px',
                                                        marginBottom: '10px',
                                                        border: '1px solid #FFF',
                                                        borderRadius: '5px',
                                                    }}>Otro Medio de Pago</RadioButton>
                                                </RadioGroup>
                                            </Col>
                                        </Row>
                                    )
                                }
                            </Form.Item>


                            <Form.Item>
                                {
                                    getFieldDecorator('plan', {
                                        rules: [
                                            {
                                                required: true
                                            }
                                        ],
                                        initialValue: null,
                                        value: this.state.planSelected
                                    })(
                                        <RadioGroup
                                            onChange={(e) => this.next(e.target.value)}
                                            buttonStyle='solid'
                                            style={{width: '100%'}}
                                        >
                                            <Row gutter={[50, 10]} type='flex' justify='center'>

                                                <Col span={6} lg={6} xs={24}>
                                                    <TablePlanCard
                                                        title={'Mensual'}
                                                        subtitle={
                                                                this.state.medioPago === 'Tarjeta' ? 
                                                                <div>
                                                                    Cobro automático <br/>
                                                                    de $ {plan[0].costo} <br/>
                                                                    cada mes
                                                                </div> : 
                                                                <div>
                                                                    Pagás una sola vez ${plan[0].costo}
                                                                </div>    
                                                            }
                                                        color="linear-gradient(90deg, #49EBAC 0%, #44C3B8 100%)"
                                                        // color= "#353FDF"
                                                        price={this.state.medioPago === 'Tarjeta' ? parseInt(plan[0].costo / plan[0].plazo) : parseInt(plan[0].costo / plan[0].plazo)}
                                                        button_value={plan[0].planId}    
                                                    />
                                                      
                                                </Col>

                                                <Col span={6} lg={6} xs={24}>
                                                    <TablePlanCard
                                                        title={
                                                            this.state.medioPago === 'Tarjeta' ? 'Semestral' : 'Trimestral'
                                                        }
                                                        subtitle={
                                                            this.state.medioPago === 'Tarjeta' ? 
                                                            <div>
                                                                Cobro automático <br/>
                                                                de $ {plan[1].costo} <br/>
                                                                cada {plan[1].plazo} meses
                                                            </div> : 
                                                            <div>
                                                                Pagás una sola vez ${plan[1].costo}
                                                            </div>    
                                                        }
                                                        color="linear-gradient(90deg, #49EBAC 0%, #44C3B8 100%)"
                                                        // color="#353FDF"
                                                        price={this.state.medioPago === 'Tarjeta' ? parseInt(plan[1].costo / plan[1].plazo) : parseInt(plan[1].costo / plan[1].plazo)}
                                                        button_value={plan[1].planId}
                                                    />
                                                </Col>

                                                <Col span={6} lg={6} xs={24}>
                                                    <TablePlanCard
                                                        title={
                                                            this.state.medioPago === 'Tarjeta' ? 'Anual' : 'Semestral'
                                                        }
                                                        subtitle={
                                                            this.state.medioPago === 'Tarjeta' ? 
                                                            <div>
                                                                Cobro automático <br/>
                                                                de $ {plan[2].costo} <br/>
                                                                cada {plan[2].plazo} meses
                                                            </div> : 
                                                            <div>
                                                                Pagás una sola vez ${plan[2].costo}
                                                            </div>    
                                                        }
                                                        color="linear-gradient(90deg, #49EBAC 0%, #44C3B8 100%)"
                                                        // color="#353FDF"
                                                        price={this.state.medioPago === 'Tarjeta' ? parseInt(plan[2].costo / plan[2].plazo) : parseInt(plan[2].costo / plan[2].plazo)}
                                                        button_value={plan[2].planId}
                                                    />
                                                </Col>
                                            </Row>
                                        </RadioGroup>
                                    )
                                }
                            </Form.Item>


                        </>
                },
            ];
            //todo
            // if (this.state.user.trabaja_aplicacion === true || this.props.login.user_data.plan === 'Aplicaciones'||this.state.trabajaEnAplicacion) {
            //     steps.splice(2, 1, planAplicaciones)
            // }
            if (this.state.trabajaEnAplicacion) {
                steps.splice(2, 1, planAplicaciones)
            }
            return (
                <>
                    {!this.props.stepsUser && <Card
                        title={
                            <Steps current={this.state.currentStep} style={{paddingLeft: '20%', paddingRight: '20%'}}>
                                {!this.props.stepsUser && steps.filter(stp => stp.title === '¿Cómo lo vas a pagar?' || stp.title === 'Elegí tu plan').map(item => (
                                    <Step key={item.title} title={item.title}/>
                                ))}
                            </Steps>
                        }
                        style={{marginBottom: 10, paddingRight: '10px', paddingLeft: '10px'}}
                        headStyle={{paddingRight: '5%', paddingLeft: '5%'}}
                        bodyStyle={{ background: '#FFF' }}
                    >
                        
                        <Form hideRequiredMark>
                            <div className="steps-content">{steps[this.state.currentStep].content}</div>
                        </Form>
                    </Card>}

                    {this.props.stepsUser &&
                    <Form hideRequiredMark>
                    { (this.state.currentStep === 2 || this.state.currentStep === 3) && 
                        <Card style={{
                        backgroundColor: "#353FDF",
                        borderColor: "#353FDF",
                        borderRadius: "5px", height: "auto", textAlign: "center", marginTop: "5px", 
                        paddingBottom: "20px", marginBottom:'5px', borderTop: '#ffffff' 
                        }}>
                            <Title 
                                level={2}
                                style={{marginBottom: "40px", color: "#FFF"}}>

                                <b>{steps[this.state.currentStep].title}</b>
                            </Title>
                            <div className="steps-content">{steps[this.state.currentStep].content}</div>
                        </Card>
                    }
                    { (this.state.currentStep !== 2 && this.state.currentStep !== 3) && 
                        <Card style={{
                        // backgroundColor: "#353FDF",
                        borderRadius: "5px", height: "auto", textAlign: "center", marginTop: "5px", paddingTop: "40px",
                        paddingBottom: "20px", marginBottom:'5px', borderTop: '#ffffff' 
                        }}>
                            <Title 
                                level={2}
                                style={{marginBottom: "40px"}}>

                                <b>{steps[this.state.currentStep].title}</b>
                            </Title>
                            <div className="steps-content">{steps[this.state.currentStep].content}</div>
                        </Card>
                    }




                    </Form>}

                    <div className="steps-action">
                        <center>
                            <Button.Group style={{marginTop: "5vh"}}>
                                {((this.props.stepsUser && this.state.currentStep > 0) || (!this.props.stepsUser && this.state.currentStep > 2)) && (
                                    <Button 
                                        className="ant-btn-stepsuser"
                                        type="primary"
                                        onClick={() => this.prev()}
                                        disabled={this.state.loading}>
                                        Anterior
                                    </Button>
                                )}
                                {(this.state.currentStep === 0) && (
                                    <Button
                                        className="ant-btn-stepsuser"
                                        type="primary"
                                        onClick={() => this.next()}>
                                        Continuar
                                    </Button>
                                )}
                            </Button.Group>
                        </center>
                    </div>
                </>
            );
        }
    }
}

const Plans = Form.create({nombre: 'plans'})(withBreakpoints(UpgradePlan));

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Plans));
